<template>
    <article class="turn_calendar">
        <div class="turn_calendar__week-row" v-for="(week,i) in currentDates" :key=i>
            <div :class="{'active': day.isToday, 'invalid_day': day.isCurMonth && propsInvalidDays.some(x => x === day.monthDay)}"
                class="turn_calendar__day-box"
                @click="changeDate(day.isCurMonth,day.monthDay,'#id')"
                v-for="(day,j) in week" :key=j>
                <h5  v-if="i==0" > {{weeks[j]}}</h5>
                <h4 :class="{'active': !day.isCurMonth}">{{day.monthDay}}</h4>
                <div v-if="day.isCurMonth && (day.monthDay in turns)"
                  class="turn_calendar__day-box__turns" >
                    <div v-for="(turn,t) in turns[day.monthDay]" :key="t">
                        <div @click="changeDate(day.isCurMonth,day.monthDay,'#idModal'), mostrarModal('#idModal',t,day.isCurMonth,day.monthDay)" :class="'turn_calendar__day-box__turns--night'">
                            {{turnHour(turns[day.monthDay][t],day.monthDay)}}
                            <span>
                            <p>{{turns[day.monthDay][t].user.name}}</p>
                            {{turns[day.monthDay][t].user.email}}
                            {{turns[day.monthDay][t].user.mobile}}
                            </span>
                        </div>
                    </div>
                </div>
                               <!-- modal -->
            <div id="idModal1" class="container__modal">
              <div class="container__modal--box">
                  <div class="container_text_top">
                    <p >¿Esta seguro que desea cancelar la reserva?</p>
                  </div>
                  <button class="button_horario_exit" @click="clickNoDelete()">NO</button>
                  <button class="button_horario_accept" @click="cancelReserva()">SI</button>
              </div>
            </div>
            <div v-show="computedModalConfirm"
              id="idModal" class="container__modal">
              <div class="container__modal--box_usuario">
                  <div
                    class="container_text_top_reserva">
                    <p> <strong>Fecha de reserva:</strong> {{fecha_calendar}}</p>
                    <p style="line-height:20px;" > <strong>Hora de reserva:</strong> {{hora}}</p>
                    <p style="line-height:20px;" ><strong>Nombre:</strong> {{name_calendar}}</p>
                    <p style="line-height:20px;" ><strong>Email:</strong> {{email_calendar}}</p>
                    <p style="line-height:20px;" v-if="mobile_calendar!=' '"><strong>Celular: </strong>{{mobile_calendar}}</p>
                  </div>
                  <button class="button_horario_exit_reserva" @click="cancel('#idModal')">Cerrar</button>
                  <button class="button_horario_accept_reserva" @click="clickCancelBooking()">Cancelar Reserva</button>

                </div>
              </div>
            <!--  -->
            </div>

        </div>
    </article>
</template>

<script>
import moment from 'moment';

export default {
  props:{
    currentMonth: {},
    unprocessedTurns: {},
    propsMonth: '',
    propsYear: '',
    sublocation_id: '',
    propsInvalidDays: '',
  },
  data(){
    return{
      prueba:'xdxd',
      dateFunc: {
        getMonthViewStartDate (date, firstDay) {
          firstDay = parseInt(firstDay);
          let start = moment(date);
          let startOfMonth = moment(start.startOf('month'));

          start.subtract(startOfMonth.day(), 'days');

          if (startOfMonth.day() < firstDay) {
            start.subtract(7, 'days');
          }
          start.add(firstDay, 'days');
          return start;
        },
        getMonthViewEndDate (date) {
          return this.getMonthViewStartDate().add(6, 'weeks');
        }
      },
      ok:0,
      hora:0,
      id_calendar:0,
      name_calendar:'',
      email_calendar:'',
      mobile_calendar:'',
      fecha_calendar:'',
      turns:{},
      weeks:['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
      modal_confirm: false,
    }
  },
  mounted() {
    this.modal_confirm = false;
  },
  methods:{

    cancelReserva(){
      console.log(this.id_calendar)
      try
      {
        this.$http.put('app/bookings/cancelled_reservation',{
          id: this.id_calendar,
        },
        {
            headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
            }).then(function(response){
              if(response.body.meta != undefined && response.body.meta != null){

                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
              this.ok=0
              const modal = document.querySelector('#idModal');
              modal.classList.remove('aparecer1')
              const modalVerificacion = document.querySelector('#idModal1');
              modalVerificacion.classList.remove('aparecer2');
              this.updateAlertMessage('Cancelación exitosa');
              this.updateIsInAlert(true);

              this.$emit('canceled-booking', { booking: this.id_calendar })
            }, function(response){
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta0authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            })
          }
          catch (e)
          {
            alert(e.message)
        }
    },
    accept(index,value){
      // this.ok=0
      // const modal = document.querySelector(value);
      // modal.classList.remove('aparecer1')
      // const modalVerificacion = document.querySelector(index);
      // modalVerificacion.classList.remove('aparecer2');
      //  this.updateAlertMessage('Cancelación exitosa');
      // this.updateIsInAlert(true);

      // // this.$router.push({name: 'access'})
      // console.log('SUBLOCATION ID!!!', this.getSublocationId())
      // this.$router.push({name: 'calendar_booking', params: { id: this.getSublocationId() } })
    },
    cancelAceptacion(value){
      this.ok=0
      const modal = document.querySelector(value);
      modal.classList.remove('aparecer2')
    },
    mostrarModalVerificacion(index){
      const modalVerificacion = document.querySelector(index);
      modalVerificacion.classList.add('aparecer2');
    },
    cancel(value){
      this.ok=0
      const modal = document.querySelector(value);
      modal.classList.remove('aparecer1')
      },
    mostrarModal(value1,id,month_active,day){
      console.log(id)
      console.log(month_active)
      console.log(this.turns[day][id].end_date)
      this.fecha_calendar = this.turns[day][id].end_date
      this.id_calendar = this.turns[day][id].id
      this.hora=this.turnHour(this.turns[day][id],this.day)
      this.name_calendar=this.turns[day][id].user.name
      this.email_calendar=this.turns[day][id].user.email
      this.mobile_calendar=this.turns[day][id].user.mobile

      const modal = document.querySelector(value1);
      modal.classList.add('aparecer1');
      },
    getCalendar () {
      this.$forceUpdate()
      //Genera el calendario
      // calculate 2d-array of each month
      let monthViewStartDate = this.dateFunc.getMonthViewStartDate(this.currentMonth, this.firstDay);
      let calendar = [];
      for(let perWeek = 0 ; perWeek < 6 ; perWeek++) {
        let week = [];
        for(let perDay = 0 ; perDay < 7 ; perDay++) {
          week.push({
            monthDay : monthViewStartDate.date(),
            isToday : monthViewStartDate.isSame(moment(), 'day'),
            isCurMonth : monthViewStartDate.isSame(this.currentMonth, 'month'),
            weekDay : perDay,
            date : moment(monthViewStartDate),
            //events : this.slotEvents(monthViewStartDate)
          });
          monthViewStartDate.add(1, 'day');

        }
        calendar.push(week);
      }
      return calendar
    },
    goToTurn(id){
      //redirecciona a la vista del turno
      this.$router.push({ path: '/turn/' + id });
    },
    processTurns(turns){
      //Procesa los turnos recibidos por el backend
      //console.log("Turnos sin procesar");
      //console.log(turns);
      var processedTurns = {}
      var getDate = function(dateString){
        return moment(dateString).format('D');
      }
      turns.forEach(function(turn){
        var day = getDate(turn.start_date);
        if(processedTurns[day]){
          processedTurns[day].push(turn);
        }else{
          processedTurns[day] = [turn];

        }
        if(turn.end_date){
          console.log(turn);
          if(turn.end_date!=turn.start_date){
            var comparable=moment('6:00','H');
            var t1 = JSON.parse(JSON.stringify(turn));
            if(moment(turn.end_hour,'H').isSameOrAfter(comparable)){
                 t1.is_diurnal=true;
            }else{
                  t1.is_diurnal=false;
            }

            if(processedTurns[parseInt(day)+1]){
              processedTurns[parseInt(day)+1].push(t1);
            }else{
              processedTurns[parseInt(day)+1] = [t1];

            }
          }
        }

      })
      //console.log("Turnos procesados");
      //console.log(processedTurns);
      return processedTurns;
    },
    turnHour(turn,day){
      var getDate = function(dateString){
        return moment(dateString).format('D');
      }
      console.log('--- turn ', turn)
      //Dado un turno retorna hora inicio y hora fin separados por guión
      if(turn.start_date==turn.end_date){

        return this.convertHourToStyleFormat(turn.start_hour) + ' - ' + this.convertHourToStyleFormat(turn.end_hour);
      }
      else if(turn.end_date==null && turn.end_hour){
        return this.convertHourToStyleFormat(turn.start_hour) + ' - ' + this.convertHourToStyleFormat(turn.end_hour)+"*";
      }
      else if(getDate(turn.start_date)==day ){
          return this.convertHourToStyleFormat(turn.start_hour) + " - ";
      }
      else{
          return ' - ' + this.convertHourToStyleFormat(turn.end_hour);
      }
    },
    convertHourToStyleFormat(hour){
      var arr=hour.split(":")
      var amOrPm="am"
      if(arr[0]>=12){
          amOrPm="pm"
          if(arr[0]>12){
          arr[0]= Number(arr[0])%12
          }
      }else if(arr[0]==0){
          arr[0]=12
      }
      if(Number(arr[0])<10){
          arr[0]="0"+Number(arr[0]).toString()
      }
      return arr[0]+":"+arr[1]+" "+amOrPm;
    },
    IsSafari() {
      var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
      return is_safari;
    },
    changeDate(month_active,day,value){
      console.log(value)
      if(value=='#idModal'){
        this.ok=1

      }
      if(this.ok==1){
        //  const modal = document.querySelector('#idModal');
        //  modal.classList.add('aparecer1');

      }else{
        if (month_active===true && this.propsInvalidDays.some(x => x === day) === false ) {
          // let dd = day;
          // if (dd < 10){
          // dd = "0" + dd
          // }
          // var userAgent = window.navigator.userAgent;
          // if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || this.IsSafari() ) {
          //     this.date_select = this.propsYear + "/" + this.propsMonth + "/" + dd + " 00:00:00"
          // }
          // else {
          //     this.date_select = this.propsYear + "-" + this.propsMonth + "-" + dd + " 00:00:00"
          // }
          // let date = new Date(this.date_select)
          // console.log('OJO ')
          // console.log('date_select ', this.date_select)
          // console.log('date ',this.date)
          // let params_sublocation_id = this.sublocation_id
          // this.$router.push({name: 'time_booking', params: {date: date, sublocation: params_sublocation_id }})
          // this.updateBookingDate(date)
          this.$router.push({name: 'booking_index'})
        }
      }
    },
    clickNoDelete(){
      this.cancelAceptacion('#idModal1')
      this.modal_confirm=false;
    },
    clickCancelBooking(){
      this.mostrarModalVerificacion('#idModal1');
      this.modal_confirm=true;
    }
  },
  computed:{
    currentDates () {
      return this.getCalendar()
    },
    computedModalConfirm() {
      // return this.modal_confirm===false
      return true
    }
  },
  created(){
    //Procesa los turnos recibidos por el backend para que puedan ser mostrados en el calendario
    this.turns = this.processTurns(this.unprocessedTurns);
  },
  watch:{
    unprocessedTurns: function(val){
      this.turns = this.processTurns(this.unprocessedTurns);

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Calendar.vue